module.exports = __webpack_public_path__ + "img/logo_zitrus.c46c330b.png";